import * as React from 'react'
import Button from '../../atoms/Button/Button'
import ModalTemplate from '../../molecules/ModalTemplate/ModalTemplate'

import * as styles from './ModalError.css'

const refresh = () => {
  location.reload()
}

interface ModalErrorProps {
  message: string | null
}

const ModalError: React.FunctionComponent<ModalErrorProps> = ({ message }) => {
  return (
    <div className={styles.container}>
      <ModalTemplate handleClick={() => null}>
        <div className={styles.modal}>
          <div className={styles.title}>
            <p className={styles.titleText}>通信エラー</p>
          </div>
          <div className={styles.body}>
            <p className={styles.bodyText}>
              {message}
              <br />
              お手数をおかけしますが、ブラウザ画面の再読み込みをお願いいたします。
            </p>
            <div className={styles.button}>
              <Button handleClick={() => refresh()}>
                <p className={styles.buttonText}>更新する</p>
              </Button>
            </div>
          </div>
        </div>
      </ModalTemplate>
    </div>
  )
}

export default ModalError
